import GdprDataItem from './gdpr-data-item'
import GdprRight from './gdpr-right'

export default {
    GdprDataItem,
    GdprRight,
}
